module.exports = __webpack_public_path__ + "img/3x.d6c8092.jpg";